import UserGuide from './UserGuide';

export default UserGuide;
